import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import TenantContext from "../../context/tenant/TenantContext";
import { toast } from "../../helper/common";
import { Button, Icon, Modal, TextField } from "../../components/design";
import "./deleteProfile.css";

const DeleteProfileModal = ({ open, onClose, currentLang }) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { softDeleteProfile } = useContext(TenantContext);
  const [deleteConfirmation, setDeleteConfirmation] = useState("");
  const [loading, setLoading] = useState(false);
  const deleteConfirmationWord = currentLang.startsWith("es")
    ? "BORRAR"
    : "DELETE";
  const canDeleteProfile =
    deleteConfirmation.trim().toUpperCase() === deleteConfirmationWord;

  const handleClose = () => {
    setDeleteConfirmation("");
    onClose();
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await softDeleteProfile();
      onClose();
      navigate("/auth");
      toast.success(_t("profileDeletedSuccessfully", "Profile deleted"));
    } catch (err) {
      toast.error(_t("failedToDeleteProfile", "Failed to delete profile"));
    } finally {
      setLoading(false);
    }
  };

  const benefits = [
    _t(
      "useItWithAnyLandlordOrAgencyToProveYourFinancialCapacity",
      "Delete profile benefit one"
    ),
    _t(
      "weCanAssessYourProfileAndActAsYourGuarantor",
      "Delete profile benefit two"
    ),
    _t(
      "automateYourRentPaymentsAndEarnRewardsForIt",
      "Delete profile benefit three"
    ),
  ];

  return (
    <Modal
      open={open}
      onClose={handleClose}
      size="sm"
      actionsLayout="row"
      icon={
        <span className="deleteProfile__icon" aria-hidden="true">
          <Icon name="trash" />
        </span>
      }
      title={_t("deleteYourSkorProfile", "Delete profile confirmation title")}
      description={_t(
        "beforeYouDecideRememberEverythingYourProfileOffers",
        "Delete profile confirmation introduction"
      )}
      actions={
        <>
          <Button variant="secondary" size="lg" onClick={handleClose}>
            {_t("keepMyProfile", "Delete profile confirmation keep action")}
          </Button>
          <Button
            variant="danger"
            size="lg"
            disabled={!canDeleteProfile}
            loading={loading}
            onClick={handleConfirm}
          >
            {_t(
              "deleteMyProfile",
              "Delete profile confirmation destructive action"
            )}
          </Button>
        </>
      }
    >
      <ul className="deleteProfile__benefits">
        {benefits.map((text) => (
          <li key={text}>
            <Icon name="check" size={18} />
            {text}
          </li>
        ))}
      </ul>
      <TextField
        id="delete-profile-confirmation"
        label={
          <>
            {_t("type", "Delete profile confirmation input label")}{" "}
            <strong>{deleteConfirmationWord}</strong>{" "}
            {_t("toConfirm", "Delete profile confirmation input label")}
          </>
        }
        value={deleteConfirmation}
        onChange={(event) => setDeleteConfirmation(event.target.value)}
        aria-label={_t(
          "deleteConfirmationWord",
          "Delete profile confirmation input"
        )}
        autoComplete="off"
      />
    </Modal>
  );
};

export default DeleteProfileModal;
